// extracted by mini-css-extract-plugin
module.exports = {"verticalMenus":"menu-list_verticalMenus__1OyrA","horizontalMenus":"menu-list_horizontalMenus__1gr7k"};